import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'nucleus-core/dialog/Dialog';
import DialogStyles from './styles/Dialog.less';
import DialogTransitionUpStyle from 'nucleus-core/less/cv/Dialog.transitionUp.less';
import { connect } from 'react-redux';
import LoadingIndicator from 'nucleus-widgets/lib/LoadingProgressIndicator/LoadingIndicator';
import Variables from './styles/Variables.less';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { isEmpty } from 'lodash';

const defaultLoadingDialogConfig = {
  requestClose: () => {},
  dialogId: 'LoadingProgressIndicatorDialog',
  header: <div />
};

export class DialogContainer extends React.Component {
  static displayName = 'DialogContainer';
  static propTypes = {
    // counter to determine if page is loading
    loading: PropTypes.number.isRequired,
    // transition time to delay in displaying the loader
    delayRenderTime: PropTypes.number,
    // transition time to delay in hiding the loader
    delayHideRenderTime: PropTypes.number,
    // config for dialog other than loading
    dialogConfig: PropTypes.object,
    // config for loading dialog
    loadingConfig: PropTypes.object,
    // object containing dialog children and loading children to display
    dialogContainerContent: PropTypes.object
  };
  static defaultProps = {
    delayRenderTime: 1500,
    delayHideRenderTime: 2500
  };
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      delayHide: false
    };
    this._doNotCloseDialog = false;
    this._dialogContainerClasses = {};
    this._delayRenderTimer = null;
    this._delayHideRenderTimer = null;
    this.setDelayRender = this.setDelayRender.bind(this);
    this.setDelayHideRender = this.setDelayHideRender.bind(this);
    this.removeDelayRender = this.removeDelayRender.bind(this);
  }
  setDelayRender(delayRenderTime, delayHideRenderTime) {
    this._delayRenderTimer = setTimeout(() => {
      this.setState({ visible: true, delayHide: true });
      this.setDelayHideRender(delayHideRenderTime);
    }, delayRenderTime);
  }
  removeDelayRender() {
    clearTimeout(this._delayRenderTimer);
    this._delayRenderTimer = null;
    this.setState({ visible: false });
  }
  setDelayHideRender(delayHideRenderTime) {
    this._delayHideRenderTimer = setTimeout(() => {
      this.setState({ delayHide: false });
    }, delayHideRenderTime);
  }
  componentDidMount() {
    // Add a delay before showing progress indicator dialog so that it
    // does not show a flicker in the screen
    if (this.props.loading > 0) {
      this.setDelayRender(this.props.delayRenderTime, this.props.delayHideRenderTime);
    }
    if (this.props.dialogConfig.isOpen) {
      this._dialogContainerClasses = { classes: this.props.classes };
    } else {
      this._dialogContainerClasses = {};
    }
  }
  componentWillReceiveProps(newProps) {
    if (newProps.loading > 0 && this.props.loading === 0) {
      this.setDelayRender(newProps.delayRenderTime, newProps.delayHideRenderTime);
    } else if (newProps.loading === 0 && this.props.loading > 0) {
      this.removeDelayRender();
    }
    if (this.props.dialogConfig.isOpen || newProps.dialogConfig.isOpen) {
      this._dialogContainerClasses = { classes: newProps.classes };
    } else if (!newProps.dialogConfig.isOpen && !isEmpty(this._dialogContainerClasses)
    && !((this.state.visible && newProps.loading > 0) || this.state.delayHide)) {
      this._dialogContainerClasses = {};
    }
    this._doNotCloseDialog = this.props.loading === 0 &&
      this.props.dialogConfig.isOpen === newProps.dialogConfig.isOpen &&
      newProps.dialogConfig.isOpen;
  }
  componentWillUnmount() {
    clearTimeout(this._delayRenderTimer);
    clearTimeout(this._delayHideRenderTimer);
    this._dialogContainerClasses = {};
  }
  render() {
    const { loading, dialogConfig, loadingConfig, dialogContainerContent } = this.props;
    const isLoading = loading > 0;
    const showLoading = (this.state.visible && isLoading) || this.state.delayHide;
    const showDialog = (showLoading || (dialogConfig.isOpen && (!isLoading || this._doNotCloseDialog)));
    const loadingDialogConfig = {
      ...defaultLoadingDialogConfig,
      ...loadingConfig,
      isAnimatable: (showLoading && !dialogConfig.isOpen ? false : dialogConfig.isAnimatable)
    };
    const dialogContainerStyling = this._dialogContainerClasses.classes ?
      this._dialogContainerClasses : { classes: DialogStyles };
    return (
      <Dialog
        { ...(showLoading ? { ...loadingDialogConfig } : dialogConfig) } isOpen={showDialog} >
        <div { ...resolve(dialogContainerStyling, 'dialogContainer')}>
          { showLoading &&
            <div className="loadingChildren">
              {dialogContainerContent.loadingChildren}
            </div>
          }
          <div className={showLoading ? DialogStyles.hidden : 'dialogChildren'}>
            {dialogContainerContent.dialogChildren}
          </div>
        </div>
      </Dialog>
    );
  }
}

export default connect((state, props) => {
  const translate = state.text.translate;
  const { dialog: { children: dialogChildren, ...otherDialogConfig },
    isLoading, pageTransitionLoading } = state.dialogContainer;
  const { spinnerMessage, message } = props;
  return {
    loading: isLoading + pageTransitionLoading,
    classes: otherDialogConfig.classes,
    dialogConfig: {
      ...otherDialogConfig,
      classes: {
        ...DialogStyles,
        transition: DialogTransitionUpStyle,
        ...otherDialogConfig.classes
      }
    },
    dialogContainerContent: {
      dialogChildren,
      loadingChildren: (
        <LoadingIndicator
          spinnerMessage={translate(spinnerMessage)}
          message={translate(message)}
          classes={DialogStyles}/>
      )
    },
    loadingConfig: {
      classes: {
        ...DialogStyles,
        transition: DialogTransitionUpStyle
      },
      style: {
        dragContainer: {
          height: Variables.dialogHeight
        }
      }
    },
    translate
  };
})(DialogContainer);
